import axios from '../axios'

/*
 * 數據模塊
 */
//查询云盘列表
export const getImageList = (data) => {
  return axios({
    url: '/api/yunpan/find',
    method: 'get',
    params: data
  })
};

//查询云盘列表
export const addImage = (data) => {
  return axios({
    url: '/api/yunpan/add',
    method: 'post',
    data: data
  })
};


//查询云盘列表
export const yunpanInfo = (data) => {
  return axios({
    url: '/api/yunpan',
    method: 'get',
    params: data
  })
};


//修改云盘信息
export const updateYunpan = (data) => {
  return axios({
    url: '/api/yunpan/update',
    method: 'post',
    data: data
  })
};


// WEBPACK FOOTER //
// ./src/http/moudules/cloudservice.js